export const addZero = number => {
    return number < 10 ? "0" + number : number;
}